import { render, staticRenderFns } from "./UserGroupCourseAssignment.vue?vue&type=template&id=e9b3e2c6"
import script from "./UserGroupCourseAssignment.vue?vue&type=script&lang=js"
export * from "./UserGroupCourseAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports